






















































import { Component, Vue, Prop, PropSync } from "vue-property-decorator";
import DButton from '@/components/DButton/button.vue';
import DxPopup from "devextreme-vue/popup";

@Component({
  name: "SimpleChoicePopup",
  components: {
    DxPopup,
    DButton,
  }
})
export default class extends Vue {
@PropSync('popupOptions') public localPopupOptions: any;
@PropSync('recalcDisable') public disableReCalc: boolean;
@PropSync('confirmDisable') public disableDontCalc: boolean;

onShowing() {}

reCalc() {
  this.emitChoiсe('recalc')
  this.onClose();
}

dontCalc() {
  this.emitChoiсe('correct')
  this.onClose();
}

onCancel() {
  this.emitChoiсe(null)
  this.onClose();
}

emitChoiсe(choice: string |  null) {
  this.$emit('choiсeDone', choice, this.localPopupOptions.idx, this.localPopupOptions.block)
}


onClose() {
  this.localPopupOptions.idx = null;
  this.localPopupOptions.visible = false;
}

}
